(function () {
  'use strict';

  function initializeCarousel(root) {
    if (!root || root.getAttribute('data-merlons-carousel-ready') === 'true') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-merlons-carousel-card]'));
    var previousButton = root.querySelector('[data-merlons-carousel-previous]');
    var nextButton = root.querySelector('[data-merlons-carousel-next]');
    var counter = root.querySelector('[data-merlons-carousel-counter]');
    var stage = root.querySelector('[data-merlons-carousel-stage]');
    var activeIndex = 0;
    var pointerStartX = null;

    if (!cards.length) return;
    root.setAttribute('data-merlons-carousel-ready', 'true');

    function stopPlayers() {
      cards.forEach(function (card) {
        var player = card.querySelector('.merlons-video-carousel__player');
        var playButton = card.querySelector('[data-merlons-carousel-video-id]');
        if (player) player.remove();
        if (playButton) playButton.hidden = false;
      });
    }

    function updateCarousel(nextIndex, options) {
      var settings = options || {};
      var total = cards.length;
      activeIndex = (nextIndex + total) % total;

      if (!settings.keepPlayer) stopPlayers();

      cards.forEach(function (card, index) {
        var position = 'hidden';
        if (index === activeIndex) position = 'current';
        else if (index === (activeIndex - 1 + total) % total) position = 'previous';
        else if (index === (activeIndex + 1) % total) position = 'next';

        card.setAttribute('data-merlons-carousel-position', position);
        card.setAttribute('aria-hidden', position === 'hidden' ? 'true' : 'false');

        var playButton = card.querySelector('[data-merlons-carousel-video-id]');
        if (playButton) playButton.tabIndex = position === 'hidden' ? -1 : 0;
      });

      if (counter) counter.textContent = (activeIndex + 1) + ' / ' + total;
    }

    function playVideo(button) {
      var card = button.closest('[data-merlons-carousel-card]');
      var cardIndex = Number(card && card.getAttribute('data-merlons-carousel-index'));
      var videoId = button.getAttribute('data-merlons-carousel-video-id');

      if (!videoId || !card || Number.isNaN(cardIndex)) return;

      if (cardIndex !== activeIndex) {
        updateCarousel(cardIndex);
        card = cards[activeIndex];
        button = card.querySelector('[data-merlons-carousel-video-id]');
      }

      if (!button || button.hidden) return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title = button.getAttribute('aria-label') || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.loading = 'eager';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.className = 'merlons-video-carousel__player';
      iframe.tabIndex = 0;

      button.hidden = true;
      card.querySelector('[data-merlons-carousel-media]').appendChild(iframe);
      window.setTimeout(function () { iframe.focus(); }, 0);
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () { updateCarousel(activeIndex - 1); });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () { updateCarousel(activeIndex + 1); });
    }

    root.addEventListener('click', function (event) {
      var playButton = event.target.closest('[data-merlons-carousel-video-id]');
      if (playButton && root.contains(playButton)) playVideo(playButton);
    });

    root.addEventListener('keydown', function (event) {
      if (event.target && event.target.tagName === 'IFRAME') return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        updateCarousel(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        updateCarousel(activeIndex + 1);
      }
    });

    if (stage) {
      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        pointerStartX = event.clientX;
      });
      stage.addEventListener('pointerup', function (event) {
        if (pointerStartX === null) return;
        var distance = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(distance) < 44) return;
        updateCarousel(activeIndex + (distance < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', function () { pointerStartX = null; });
    }

    root.addEventListener('merlons:carousel:select', function (event) {
      var selectedIndex = Number(event.detail && event.detail.index);
      if (!Number.isNaN(selectedIndex)) updateCarousel(selectedIndex);
    });

    updateCarousel(0);
  }

  function initializeAll(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-merlons-video-carousel]').forEach(initializeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest('[data-merlons-carousel-card]');
    var root = event.target.closest('[data-merlons-video-carousel]');
    if (!card || !root) return;
    root.dispatchEvent(new CustomEvent('merlons:carousel:select', {
      detail: { index: Number(card.getAttribute('data-merlons-carousel-index')) }
    }));
  });
}());
